import { Directive, HostListener, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[OnlyNumber]', standalone: false
})
export class OnlyNumberDirective {
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  @Input() OnlyNumber: boolean;
  @Input() allowCharacters = '';

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    if (this.OnlyNumber) {
      if (
        this.isBacKSpace(e.key) ||
        this.isActionControl(e) ||
        ['Home', 'End', 'ArrowLeft', 'ArrowLeft'].includes(e.key) ||
        this.isNumber(e.key) ||
        (!this.elementRef.nativeElement.value.includes(e.key) &&
          this.allowCharacters.includes(e.key))
      ) {
        return;
      }
      e.preventDefault();
    }
  }

  private isNumber(key: string) {
    return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(key);
  }

  private isActionControl(e: KeyboardEvent) {
    return (
      (e.ctrlKey || e.metaKey) &&
      ['a', 'A', 'c', 'C', 'v', 'V', 'x', 'X'].includes(e.key)
    );
  }

  private isBacKSpace(key: string) {
    return key === 'Backspace';
  }
}
